module.exports = ".ui-tree .ui-tree-container {\n  height: 423px !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/fin/accounts/accounts-show/accounts-show.component.scss
// module id = ./src/app/views/fin/accounts/accounts-show/accounts-show.component.scss
// module chunks = main